<template>
  <div class="contact margin-between-section margin-bottom-section">
    <div class="row not-margin">
      <div class="col-md-12 container-info">
        <div class="info-a">
          <h1>Pragmatic Scouting.</h1>
          <p>contacto@pragmaticscouting.com</p>
        </div>
      </div>
    </div>
    <div class="margin-between-section">
      <div class="row not-margin ">
        <div class="col-md-6 container-info">
          <div class="info">
            <ul>
              <!--<li><a target="_blank" href="#"><img src="../assets/images/facebook_icon.png"/> </a></li>-->
              <li><a target="_blank" href="https://twitter.com/pragmaticscout"><img src="../assets/images/twitter_icon.png"/> </a></li>
              <li><a target="_blank" href="https://www.instagram.com/pragmatic_scouting/"><img src="../assets/images/instagram_icon.png"/> </a></li>
            </ul>
          </div>
        </div>
        <div class="col-md-6 not-padding">
          <div class="info-form-contact">
            <p>{{ $t('home.footer')}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'contact',
  data(){
    return{
    }
  }
};

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.info-a{
  text-align: left;
}

.info-a h1{
  font-size: 25px;
  font-family: 'plain regular', arial
}

.info-a p{
  padding-top: 5%;
  font-size: 12px;
}

.container-info{
  display: flex;
}


.not-margin{
  margin: 0;
}
.not-padding{
  padding: 0;
}


.info-form-contact{
  text-align: right;
}

.info-form-contact p{
  font-size: 8px;
  margin-top: 15px;
  margin-right: 20px;
  color: rgb(151, 151, 151);
}

.send-b{
  border: 1px solid #000;
  border-radius: 0;
  margin-left: 0px;
  font-size: 12px;
  padding: 5px 30px;
  margin-bottom: 9px;
}

ul{
  list-style: none;
  margin: 0;
  padding: 0;
}

ul li {
  display: inline;
  margin: 10px;
}

.margin-bottom-section{
  margin-bottom: 5%;
}
</style>
